// extracted by mini-css-extract-plugin
export default {"flexContainer":"ChatEnd_flexContainer__BrQv+","chatEndContainer":"ChatEnd_chatEndContainer__4lVN7"};